module.exports = __webpack_public_path__ + "static/media/Theatre.2f742ebb.JPG";